/* eslint-disable no-underscore-dangle */
import React, { useCallback, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import { Button, P, Icon } from '@fashionnovateam/nova-ui-toolkit';
import Page from '../Page/index';
import Header from '../Header/index';
import { ContactDrawer } from '../Navigation/ContactDrawer';
import { HomeView } from './Pages/HomeView';
import { SectionView } from './Pages/SectionView';
import { ArticleView } from './Pages/ArticleView';
import { HelpCenterNavigation } from './Navigation/HelpCenterNavigation';
import { NavigationProvider } from '../../Lib/Hooks/navigation';
import { useHelpCenterData } from '../../Lib/Hooks/help-center.hooks';
import { PageLoading } from '../PageLoading/PageLoading';
import { HelpCenterPageProps } from './types';

export function HelpCenterPage({ user }: HelpCenterPageProps) {
  const [isContactDrawerOpen, setIsContactDrawerOpen] = useState(false);
  const { data: helpCenterData, isLoading, error } = useHelpCenterData(user.id);

  const toggleDrawer = useCallback(() => {
    setIsContactDrawerOpen((prev) => !prev);
  }, []);

  if (isLoading) {
    return <PageLoading />;
  }

  if (error) {
    return (
      <Page.Container>
        <div className="flex flex-col items-center justify-center h-full">
          <Icon name="alert/alert-circle" className="mb-4" />
          <P>Failed to load help center content. Please try again later.</P>
        </div>
      </Page.Container>
    );
  }
  if (!helpCenterData) return null;
  return (
    <Page.Container>
      <Header.Major icon="question/question-mark-circle" title="Help Center">
        <div className="flex items-center space-x-4">
          <P size="xs" className="hidden md:block">
            Still have questions?
          </P>
          <Button size="sm" color="secondary" onClick={toggleDrawer}>
            <Icon name="send-plane/send-plane-slant" />
            <span className="hidden md:inline">Contact Us</span>
          </Button>
        </div>
      </Header.Major>

      <div className="flex flex-col md:flex-row flex-1 overflow-hidden">
        <NavigationProvider>
          <HelpCenterNavigation
            sections={helpCenterData.sections}
            user={user}
          />
        </NavigationProvider>

        <div className="flex-1 pt-6 md:pt-12 px-4 md:px-12 lg:px-20 overflow-y-auto">
          <Switch>
            <Route
              path="/users/:userId/help-center"
              exact
              render={() => (
                <HomeView
                  helpCenterData={helpCenterData}
                  onContactClick={toggleDrawer}
                />
              )}
            />
            <Route
              path="/users/:userId/help-center/:sectionTitle"
              exact
              render={() => <SectionView helpCenterData={helpCenterData} />}
            />
            <Route
              path="/users/:userId/help-center/:sectionTitle/:articleId"
              exact
              render={() => <ArticleView helpCenterData={helpCenterData} />}
            />
          </Switch>
        </div>
      </div>

      <ContactDrawer
        user={user}
        isOpen={isContactDrawerOpen}
        onClose={toggleDrawer}
      />
    </Page.Container>
  );
}
